var map = {
	"./android-dev.png": 2365,
	"./c-programming.png": 8650,
	"./cpp.png": 775,
	"./css.png": 8187,
	"./django.jpg": 7808,
	"./expo.png": 268,
	"./firebase.png": 2229,
	"./gcp.png": 4786,
	"./gimp.png": 4179,
	"./git.png": 1538,
	"./html.png": 2127,
	"./java.png": 3055,
	"./javascript.png": 5663,
	"./jenkins.png": 9558,
	"./linux.png": 7774,
	"./microsoft-office.png": 1174,
	"./mips.png": 3338,
	"./nosql.png": 8841,
	"./postgres.png": 9080,
	"./psycopg2.png": 7915,
	"./python.png": 8442,
	"./pytorch.png": 3139,
	"./r-stats.png": 3215,
	"./reactnative.png": 3844,
	"./scripting.png": 6288,
	"./sqlite.png": 6571,
	"./tizen-web-framework.png": 5493,
	"./ts.png": 7652,
	"./vuejs.png": 4723,
	"./windows-os-logo.png": 940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3048;